<template>
  <a-modal v-model="open" :title="title" @cancel="close">
    <template slot="footer">
      <a-button key="back" @click="close">取消</a-button>
      <a-button key="submit" type="primary" :loading="submitloading" @click="submit">确定</a-button>
    </template>
    <div class="um-download">
      <h4 class="um-h4">数据模板下载</h4>
      <p align="center">
        <a href="#" @click="download" class="templateDownload">模板下载</a>
      </p>
    </div>
    <div class="um-download">
      <h4 class="um-h4">批量导入题目</h4>
    </div>
    <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" @change="unploadChange">
      <h4 class="um-upload">上传文件</h4>
      <p class="ant-upload-drag-icon">
        <a-icon type="cloud-upload" />
      </p>
      <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
      <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
    </a-upload-dragger>
    <a @click="down()" v-if="errorFile" style="text-align: center; margin: 20px 0; display: block; color: #f00">点击这里下载错误数据</a>
  </a-modal>
</template>
<script>
import * as XLSX from 'xlsx'
export default {
  name: 'ImportModal',
  props: {
    title: [String],
    toJson: Boolean,
    templateUrl: String,
    downloadName: {
      type: String,
      default: 'template.xlsx',
    },
  },
  data() {
    return {
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/Question_Import_Template.xlsx',
      fileList: [],
      errorFile: false,
      open: false,
      submitloading: false,
    }
  },
  methods: {
    showModal() {
      return new Promise((res, rej) => {
        this._res = res
        this._rej = rej
        this.open = true
      })
    },
    async submit() {
      let data = null
      this.submitloading = true
      if (this.toJson) {
        data = await this.xlsxToJson(this.fileList[0])
      } else {
        data = this.fileList[0]
      }
      this.submitloading = false
      this._res(JSON.parse(JSON.stringify(data)))
      this.close()
    },
    close() {
      this._rej()
      this.fileList = []
      this.open = false
    },
    download() {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', this.templateUrl, true)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        const blob = xhr.response
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = this.downloadName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    xlsxToJson(file) {
      if (!file) return Promise.reject()
      return new Promise((reslove) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet)
          console.log('解析的 JSON 数据:', jsonData)
          reslove(jsonData)
        }
        reader.readAsArrayBuffer(file)
      })
    },
    preview(record) {
      console.log(record)
      this.qusetionItem = record
      this.ispreview = true
      this.num = record.questionItems.filter((item) => {
        return item.itemType == 0
      })
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      const bool = this.fileList.filter((v) => v.name === file.name).length
      if (bool) {
        this.$message.warning('已有相同的文件，请重新选择文件')
        return false
      }
      this.fileList = [file]
      return false
    },
    unploadChange(value) {
      if (value.fileList.length) {
        this.file = value.file
      } else {
        this.file = ''
      }
    },
    // 下载错误原因
    down() {
      window.open(this.$filterUrl(this.errorUrl))
    },
  },
}
</script>
